import { Inject, Injectable } from '@angular/core';
import { PLATFORM_API_URL } from '@core/constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class IcaHttpService {
  constructor(
    private readonly http: HttpClient,
    @Inject(PLATFORM_API_URL) private readonly platformApiUrl: string
  ) {}
 
  getICADocumentLink(authorizationId: string, tenantId: string): Observable<string> {
    return this.http.get(`${this.platformApiUrl}/api/ICASummaryView/GetSummaryViewLink/authorizationId/${authorizationId}/tenantId/${tenantId}`, {responseType: 'text'});
  }
}